import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Collapse,
  Box,
  Typography,
  Divider,
  IconButton,
  Chip
} from '@mui/material';
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Receipt as ReceiptIcon,
  AttachMoney as AttachMoneyIcon
} from '@mui/icons-material';


const session = require('../../config/session');

class RetirosTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retiros: [],
      filaExpandida: null,
      detallesActivos: []
    };
  }

  handleExpand = (retiro, index) => {
    const yaExpandida = this.state.filaExpandida === index;

    if (yaExpandida) {
      this.setState({ filaExpandida: null, detallesActivos: [] });
    } else {
      const fechaRecaudoExacta = retiro.fecha_recaudo_datetime;

      this.props.queryDetalles(fechaRecaudoExacta, (data) => {
        this.setState({ filaExpandida: index, detallesActivos: data });
      });
    }
  };

  calcularArqueo = () => {
    
    const arqueoMap = new Map();

    this.state.detallesActivos.forEach((detalle) => {
     
      const contenido = detalle.detalle ? JSON.parse(detalle.detalle) : {};
      const secciones = Object.values(contenido);

      secciones.forEach((seccion) => {
        if (seccion?.currencies) {
          seccion.currencies.forEach((currency) => {
            currency.bills.forEach((bill) => {
              const denom = bill.denomination;
              const cantidad = bill.amount;
              if (arqueoMap.has(denom)) {
                arqueoMap.set(denom, arqueoMap.get(denom) + cantidad);
              } else {
                arqueoMap.set(denom, cantidad);
              }
            });
          });
        }
      });
    });

    const arqueoFinal = Array.from(arqueoMap.entries())
      .sort((a, b) => b[0] - a[0]) // Orden descendente por denominación
      .map(([denominacion, cantidad]) => ({
        denominacion,
        cantidad,
        subtotal: denominacion * cantidad
      }));

    return arqueoFinal;
  };

  render() {
    const { filaExpandida, detallesActivos } = this.state;
    const retiros = this.props.retiros;
  
    const columns = [
      { field: "desplegable", headerName: "", width: 70 },
      { field: "fecha_recaudo", headerName: 'Fecha recaudo', width: 180 },
      { field: "codigo_cajero", headerName: 'Cajero', width: 150 },
      { field: "nombre_entidad", headerName: 'Entidad', width: 200 },
      { field: "valor", headerName: 'Valor', width: 120, align: 'right' }
    ];
  
    const arqueo = this.calcularArqueo();
    const totalArqueo = arqueo.reduce((acc, item) => acc + item.subtotal, 0);
  
    return (
      <Paper sx={{ 
        width: '100%',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        mb: 3
      }}>
        <TableContainer>
          <Table stickyHeader sx={{ minWidth: 750 }}>
            <TableHead>
              <TableRow sx={{
                '& th': {
                  backgroundColor: 'primary.main',
                  color: 'primary.contrastText',
                  fontWeight: 'fontWeightBold',
                  fontSize: '0.8rem',
                  py: 1.5,
                  px: 2
                }
              }}>
                {columns.map((column) => (
                  <TableCell
                    key={column.field}
                    sx={{
                      width: column.width,
                      textAlign: column.align || 'left',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
  
            <TableBody>
              {retiros.map((retiro, index) => {
                const estaAbierta = filaExpandida === index;
                const fechaFormateada = DateTime.fromFormat(retiro.fecha_recaudo, 'dd/MM/yyyy').toFormat('yyyy-MM-dd');
  
                return (
                  <React.Fragment key={index}>
                    <TableRow sx={{
                      '&:hover': { backgroundColor: 'action.hover' },
                      '& td': { 
                        py: 1.5,
                        px: 2,
                        borderBottom: estaAbierta ? 'none' : undefined
                      }
                    }}>
                      <TableCell>
                        <IconButton 
                          size="small" 
                          onClick={() => this.handleExpand(retiro, index)}
                          color={estaAbierta ? 'primary' : 'default'}
                        >
                          {estaAbierta ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                      </TableCell>
                      <TableCell>{retiro.fecha_recaudo_completa}</TableCell>
                      <TableCell>
                        {session.checkPermiso('acceder_cajeros_resumen') ? (
                           <Link to={{ pathname: '/dashboard/cajeros/resumen', state: { id_cajero: retiro.id_cajero } }}>
                           {retiro.codigo_cajero}
                            </Link>
                          ) : (
                            <span>{retiro.codigo_cajero}</span>
                          )}                         
                        </TableCell>
                      <TableCell>{retiro.nombre_entidad}</TableCell>
                      <TableCell sx={{ 
                        fontWeight: 'fontWeightMedium',
                        textAlign: 'right',
                        color: 'success.main'
                      }}>
                        {retiro.valor.toLocaleString()}
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell colSpan={5} sx={{ 
                        p: 0,
                        borderBottom: `1px solid`,
                        borderColor: 'divider'
                      }}>
                        <Collapse in={estaAbierta} timeout="auto" unmountOnExit>
                          <Box sx={{ 
                            backgroundColor: 'background.default',
                            borderLeft: 4,
                            borderColor: 'primary.main',
                            p: 3
                            }}>
                            
                            {/* Sección Arqueo */}
                            <Box mt={4}>
                              <Box display="flex" alignItems="center" mb={2}>
                                <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                  Desglose de Efectivo
                                </Typography>
                              </Box>
                              <Divider sx={{ mb: 2 }} />
  
                              <Table size="small" sx={{ 
                                '& th': {
                                  backgroundColor: 'action.selected',
                                  fontWeight: 'fontWeightBold'
                                },
                                '& td, & th': {
                                  py: 1,
                                  px: 2
                                }
                              }}>
                                <TableHead>
                                  <TableRow>
                                    <TableCell sx={{ width: 100 }}>Denominacion</TableCell>
                                    <TableCell sx={{ textAlign: 'right' }}>Cantidad</TableCell>
                                    <TableCell sx={{ textAlign: 'right' }}>Subtotal</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {arqueo.map((row, idx) => (
                                    <TableRow key={idx} hover>
                                      <TableCell>{row.denominacion.toLocaleString()}</TableCell>
                                      <TableCell sx={{ textAlign: 'right' }}>{row.cantidad}</TableCell>
                                      <TableCell sx={{ 
                                        textAlign: 'right',
                                        fontWeight: 'fontWeightMedium'
                                      }}>
                                        ${row.subtotal.toLocaleString()}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                                <TableFooter>
                                  <TableRow sx={{ 
                                    '& td': {
                                      fontWeight: 'fontWeightBold',
                                      backgroundColor: 'action.selected'
                                    }
                                  }}>
                                    <TableCell>Total</TableCell>
                                    <TableCell />
                                    <TableCell sx={{ textAlign: 'right' }}>
                                      {totalArqueo.toLocaleString()}
                                    </TableCell>
                                  </TableRow>
                                </TableFooter>
                              </Table>
                            </Box>
                            {/* Sección Detalles */}
                            <Box mb={4} mt={4}>
                              <Box display="flex" alignItems="center" mb={2} sx={{ mr: 5 }} >
                                <ReceiptIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" fontWeight="fontWeightBold">
                                  Detalles del recaudo
                                </Typography>
                              </Box>
                              <Divider sx={{ mb: 2 }} />
  
                              <Table size="small" sx={{ 
                                '& th': {
                                  backgroundColor: 'action.selected',
                                  fontWeight: 'fontWeightBold'
                                },
                                '& td, & th': {
                                  py: 1,
                                  px: 2
                                }
                              }}>
                                <TableHead>
                                  <TableRow>
                                    <TableCell sx={{ width: 200 }}>Fecha deposito</TableCell>
                                    <TableCell sx={{ width: 200 }}>Cliente</TableCell>
                                    <TableCell sx={{ width: 150, textAlign: 'right' }}>Valor</TableCell>
                                    <TableCell sx={{ width: 200 }}>Aprobacion</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {detallesActivos.map((detalle, i) => (
                                    <TableRow key={i} hover>
                                      <TableCell>{detalle.fecha_dispositivo}</TableCell>
                                      <TableCell>{detalle.nombre_cliente}</TableCell>
                                      <TableCell sx={{ textAlign: 'right', fontWeight: 'fontWeightMedium' }}>
                                        {detalle.valor.toLocaleString()}
                                      </TableCell>
                                      <TableCell>
                                        <Chip 
                                          label={detalle.aprobacion} 
                                          size="small"
                                          color={detalle.aprobacion === 'Aprobado' ? 'success' : 'default'}
                                          variant="outlined"
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }
}

export default RetirosTable;




/* function Row(props) {
 const {retiro} = props;
 const [open, setOpen] = React.useState(false)

 var detalle = (retiro.detalle !== '' ? JSON.parse(retiro.detalle) : '')
 var filaDetalle = []

 for(var campo in detalle) {
  if(campo === 'billetes') {
    var filasBilletes = RowBilletes(detalle[campo])
    filaDetalle.push(
      <TableRow>
       <TableCell className="sub-detalle-titulo">{campo}</TableCell>
       <TableCell className="sub-detalle-valor">{filasBilletes}</TableCell>
      </TableRow>
    )
  } else {
    filaDetalle.push(
      <TableRow>
       <TableCell className="sub-detalle-titulo">{campo}</TableCell>
       <TableCell className="sub-detalle-valor">{detalle[campo]}</TableCell>
      </TableRow>
    )
  }
 }


 return (
   <React.Fragment>
     <TableRow sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'fontWeightBold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2
                  }
                }}>
      <TableCell>
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
        >
          {open ? <KeyboardArrowUpIcon />:<KeyboardArrowDownIcon />}
        </IconButton>
      </TableCell>
       <TableCell>
         {retiro.fecha_registro}
       </TableCell>
       <TableCell>
         {retiro.entidad}
       </TableCell>
       <TableCell>
         {retiro.referencia_pago}
       </TableCell>
       <TableCell>
         {retiro.valor}
       </TableCell>
       <TableCell>
         {retiro.finalizacion}
       </TableCell>
       <TableCell>
         {retiro.aprobacion}
       </TableCell>
       <TableCell>
         {retiro.fecha_aprobacion}
       </TableCell>
     </TableRow>
     <TableRow>
     </TableRow>
     <TableRow>
      <TableCell style={{paddingTop: 0, paddingBottom: 0}} colSpan={10}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Table className="detalle">
            <TableRow>
              <TableCell className="sub-detalle-titulo">Fecha Dispositivo</TableCell>
              <TableCell className="sub-detalle-valor">{retiro.fecha_dispositivo}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="sub-detalle-titulo">Consecutivo</TableCell>
              <TableCell className="sub-detalle-valor">{retiro.consecutivo}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="detalle-titulo">
                Detalle
              </TableCell>
              <TableCell className="detalle-valor">
                <Table>
                  {filaDetalle}
                </Table>
              </TableCell>
            </TableRow>
          </Table>
        </Collapse>
      </TableCell>
     </TableRow>
   </React.Fragment>
 );
}

function RowBilletes(billetes) {
  /* eslint-disable no-redeclare */
  //var billetes = billetes.split(',')
  /* eslint-enable no-redeclare */

 /*  var filasBilletes = []
  for(var billete in billetes) {
    filasBilletes.push(
      <TableRow>
       <TableCell>{billetes[billete]}</TableCell>
      </TableRow>
    )
  }

  return(
    <Table>
      {filasBilletes}
    </Table>
  )
} */

/* class RetirosTable extends Component {

  constructor(props) {
    super(props)

    this.state = {
      retiros: []
    };
  }



  componentDidMount() {
    //this.queryEventos()
  }

  render() {
    const retiros = this.props.retiros
    const columns = [
      {field: "desplegable", headerName: "", width: 10},
      {field: "fecha_hora", headerName: 'Fecha Registro', width: 150},
      {field: "entidad", headerName: 'Entidad', width: 100},
      {field: "referencia_pago", headerName: 'Referencia Pago', width: 100},
      {field: "valor", headerName: 'Valor', width: 150},
      {field: "finalizacion", headerName: 'Finalizacion', width: 150},
      {field: "aprobacion", headerName: 'Aprobacion', width: 150},
      {field: "fecha_aprobacion", headerName: 'Fecha Aprobacion', width: 150},
    ]

    return (
      <Paper sx={{ width: 1200, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'fontWeightBold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2
                  }
                }}>
                {columns.map((column) => {
                  return(
                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {retiros.map((retiro) => {
                return(
                  <Row retiro={retiro} />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }
}  */
